var pad = require('./pad');

module.exports = function rpad(str, length, padStr) {
  return pad(str, length, padStr, 'right');
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/rpad.js
// module id = 2284
// module chunks = 0